var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7504 2.375C21.977 2.375 23.9943 3.23371 25.4385 4.79305C26.9007 6.37168 27.6132 8.49656 27.4447 10.7751C27.11 15.3106 23.664 19 19.7504 19C15.8369 19 12.385 15.3098 12.0554 10.7736C11.8892 8.4743 12.5972 6.34496 14.0504 4.7782C15.488 3.22852 17.512 2.375 19.7504 2.375ZM6.68792 35.625H32.8129C33.5056 35.6338 34.1653 35.3301 34.609 34.7982C35.0914 34.2215 35.2859 33.4341 35.1419 32.6377C34.5155 29.1628 32.5606 26.2437 29.4879 24.1953C26.7582 22.377 23.3003 21.375 19.7504 21.375C16.2005 21.375 12.7427 22.3762 10.0129 24.1953C6.94027 26.2445 4.98535 29.1635 4.35894 32.6384C4.21496 33.4348 4.40941 34.2223 4.89183 34.7989C5.33569 35.3306 5.99541 35.634 6.68792 35.625Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d5e81dcd74367dcab2092652841f88f4.svg";
export { ForwardRef as ReactComponent };